export enum WebErrorType {
    StudentSignupError = "student_signup_error",
    ServerError = "server_error",
    AccountDisabled = "account_disabled"
}
